jQuery(document).ready(function () {
// Open modal
jQuery(document).on('click', '.open-modal', function() {
    // Get the index from the data attribute
    var index = jQuery(this).data('index');
    // Show the corresponding modal
    document.getElementById('modal__' + index).showModal();
});

// Close modal
jQuery(document).on('click', '.close-modal', function() {
    var dialog = jQuery(this).closest('dialog')[0];
    dialog.setAttribute('closing', '');
    dialog.addEventListener('animationend', function() {
        dialog.removeAttribute('closing');
        dialog.close();
    }, {once: true});
});

// Optional: Close the modal when clicking outside of it
jQuery(document).on('click', 'dialog', function(event) {
    if (event.target.nodeName === 'DIALOG') {
        var dialog = event.target;
        dialog.setAttribute('closing', '');
        dialog.addEventListener('animationend', function() {
            dialog.removeAttribute('closing');
            dialog.close();
        }, {once: true});
    }
});
});